import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-8_waichu",
  "use": "icon-8_waichu-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-8_waichu\">\n<rect x=\"14\" y=\"12\" width=\"12\" height=\"9\" rx=\"2\" stroke=\"#81B9FF\" stroke-width=\"3\" />\n<path d=\"M9 18C9 16.3431 10.3431 15 12 15H28C29.6569 15 31 16.3431 31 18V28C31 29.6569 29.6569 31 28 31H12C10.3431 31 9 29.6569 9 28V18Z\" fill=\"#3992FF\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23 18.75C23.4142 18.75 23.75 19.0858 23.75 19.5V20.25H28C28.4142 20.25 28.75 20.5858 28.75 21C28.75 21.4142 28.4142 21.75 28 21.75H23.75V22.5C23.75 22.9142 23.4142 23.25 23 23.25C22.5858 23.25 22.25 22.9142 22.25 22.5V21.75H17.75V22.5C17.75 22.9142 17.4142 23.25 17 23.25C16.5858 23.25 16.25 22.9142 16.25 22.5V21.75H12C11.5858 21.75 11.25 21.4142 11.25 21C11.25 20.5858 11.5858 20.25 12 20.25H16.25V19.5C16.25 19.0858 16.5858 18.75 17 18.75C17.4142 18.75 17.75 19.0858 17.75 19.5V20.25H22.25V19.5C22.25 19.0858 22.5858 18.75 23 18.75Z\" fill=\"white\" fill-opacity=\"0.9\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/8_waichu.svg
// module id = ZjTJ
// module chunks = 45